/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Redact_After_LabelInputs */

const da_forside_redact_after_label = /** @type {(inputs: Forside_Redact_After_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hos os`)
};

/** @type {(inputs: Forside_Redact_After_LabelInputs) => LocalizedString} */
const en_forside_redact_after_label = da_forside_redact_after_label;

/**

* @param {Forside_Redact_After_LabelInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_redact_after_label = /** @type {((inputs?: Forside_Redact_After_LabelInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Redact_After_LabelInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_redact_after_label(inputs)
	return /** @type {LocalizedString} */ ("Hos os")
});